import { useRef } from 'react';
import { MdOutlineDone } from 'react-icons/md';
import { PiPolygonDuotone, PiRectangleDuotone, PiScanDuotone } from 'react-icons/pi';

import { useTranslate } from '@spazious/dollhouse-i18n';
import { DrawFsetupToolModeEnum } from '@spazious/dollhouse-types';
import {
  Button,
  ButtonGroup,
  ButtonGroupProps,
  ButtonProps,
  Flex,
  Stack,
  StackProps,
} from '@spazious/dollhouse-uikit';
import { useEventCallback } from '@spazious/react-hooks';

import { useDeviceInfo, useDrawFsetup } from '../../hooks/index.js';

import { ControlButton } from './ControlButton.js';

export interface ActionControlsProps extends StackProps {}
export const ActionControls: React.FC<ActionControlsProps> = ({ onClick, ...props }) => {
  return (
    <Stack {...props} justifyContent="center">
      <Button size="extraSmall" style={{ cursor: 'pointer' }} onClick={onClick as any}>
        <MdOutlineDone />
      </Button>
    </Stack>
  );
};

export interface FsetupDrawToolControlsProps extends ButtonGroupProps {}

export const FsetupDrawToolControls: React.FC<FsetupDrawToolControlsProps> = (props) => {
  const { node, set } = useDrawFsetup();
  const translate = useTranslate();

  const isMobile = useDeviceInfo((state) => state.isMobile);
  const buttonSize: ButtonProps['size'] = isMobile ? 'small' : 'medium';
  const groupRef = useRef<Element>();

  const closeControls = useEventCallback(() => {
    set({
      active: false,
    });
  });

  return node ? (
    <Flex column alignItems="center" gap="5px">
      <ButtonGroup {...props} ref={groupRef as any} alignItems="flex-start">
        <ControlButton
          hint={translate(isMobile ? 'Touch and drag to draw' : 'Click and drag to draw')}
          icon={<PiRectangleDuotone />}
          label={translate('Rectangle')}
          size={buttonSize}
          tool={DrawFsetupToolModeEnum.Rectangle}
        />
        <ControlButton
          controls={<ActionControls onClick={closeControls} />}
          controlsPortal={groupRef.current || undefined}
          // hint={translate('Tap to add point, douple tap anywhere to stop drawing')}
          icon={<PiPolygonDuotone />}
          label={translate('Polygon')}
          size={buttonSize}
          tool={DrawFsetupToolModeEnum.Polygon}
        />
        <ControlButton
          controlsPortal={groupRef.current || undefined}
          hint={translate('Tap to fill the space')}
          icon={<PiScanDuotone />}
          label={translate('Fill')}
          size={buttonSize}
          tool={DrawFsetupToolModeEnum.Fill}
        />
      </ButtonGroup>
    </Flex>
  ) : null;
};
